angular.module('zc.projects')

.directive 'campaignScheduleStep', ($filter) ->
  restrict: 'E'
  scope:
    campaign: '='
    scheduleForm: '='
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_schedule_step.html'
  link: (scope, element, attrs) ->

    scope.setToNow = (date_obj, region) ->
      date_obj.date = $filter('changeDatetimeFrom')('regionToLocal', moment().tz(region).startOf('day').valueOf())
      date_obj.time = moment().tz(region).hours() * 60

    scope.setToBeginningOfNextMonth = (date_obj, region) ->
      date_obj.date = $filter('changeDatetimeFrom')('regionToLocal', moment().tz(region).endOf('month').add(1, 'days').startOf('month').valueOf())
      date_obj.time = 0

    scope.setToBeginningOfNextNextMonth = (date_obj, region) ->
      date_obj.date = $filter('changeDatetimeFrom')('regionToLocal', moment().tz(region).endOf('month').add(1, 'months').add(15, 'days').startOf('month').valueOf())
      date_obj.time = 0

    scope.setToEndOfMonth = (date_obj, region) ->
      date_obj.date = $filter('changeDatetimeFrom')('regionToLocal', moment().tz(region).endOf('month').startOf('day').valueOf())
      date_obj.time = 23 * 60

    scope.setToEndOfNextMonth = (date_obj, region) ->
      date_obj.date = $filter('changeDatetimeFrom')('regionToLocal', moment().tz(region).endOf('month').add(1, 'days').endOf('month').startOf('day').valueOf())
      date_obj.time = 23 * 60

    scope.setToEndOfNextNextMonth = (date_obj, region) ->
      date_obj.date = $filter('changeDatetimeFrom')('regionToLocal', moment().tz(region).endOf('month').add(1, 'months').add(15, 'days').endOf('month').startOf('day').valueOf())
      date_obj.time = 23 * 60

    scope.setToInfiniteCampaign = () ->
      scope.campaign.is_infinite = true
      scope.campaign.end_at_obj.date = null
      scope.campaign.end_at_obj.time = null

    scope.setToFiniteCampaign = () ->
      scope.campaign.is_infinite = false

    scope.checkInfiniteCampaign = () ->
      scope.campaign.is_infinite

    scope.$watch 'campaign.start_at_obj.date', (startAt) ->
      scope.scheduleForm.$setValidity('startAt', !!startAt, window)
      if scope.campaign.status == 'preview' && !scope.campaign.was_activated_before
        scope.is_start_at_before_today = scope.campaign.start_at_obj.date < moment().startOf('day').valueOf()
        scope.scheduleForm.$setValidity('startAt', !scope.is_start_at_before_today, window)

    scope.$watch 'campaign.end_at_obj.date', (endAt) ->
      scope.scheduleForm.$setValidity('endAt', !!endAt || (!endAt && scope.campaign.is_infinite), window)

    scope.$watch 'campaign.is_infinite', (newValue, oldValue) ->
      if newValue == false && oldValue == true
        scope.setToNow(scope.campaign.end_at_obj, scope.campaign.region)
      if newValue == true && oldValue == false
        scope.scheduleForm.$setValidity('endAt', scope.campaign.is_infinite, window)



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_schedule_step.coffee